module.exports = __webpack_public_path__ + "img/logo.8e5448d8.svg";